import IPagination from './IPagination';

export enum UMBReservationStatus {
  Confirmed = 1,
  Completed = 2,
  Cancelled = 3,
}

export enum UMBReservationDayStatus {
  Reserved = 1,
  CheckedIn = 2,
  Cancelled = 3,
}

export interface IUMBAvailability {
  umbId: number;
  name: string;
  code: string;
  areaId?: number | null;
  areaName?: string | null;
  rowId: number;
  rowName?: string | null;
  rowCode?: string | null;
  firstPrice: number;
  secondPrice: number;
  isBusy: boolean;
  isAvailableForEntireRange: boolean;
  conflictingDates: string[];
  conflictingReservationId?: number | null;
}

export interface IUMBReservationDay {
  id: number;
  serviceDate: string;
  status: UMBReservationDayStatus;
  isActive: boolean;
  umbInventoryId?: number | null;
  checkedInAt?: string | null;
}

export interface IUMBReservationItem {
  id: number;
  umbId: number;
  umbName: string;
  umbCode: string;
  areaId?: number | null;
  areaName?: string | null;
  lockedDailyPrice: number;
  isBusy: boolean;
  days: IUMBReservationDay[];
}

export interface IUMBReservation {
  id: number;
  customerName: string;
  customerPhone?: string | null;
  customerEmail?: string | null;
  startDate: string;
  endDate: string;
  status: UMBReservationStatus;
  notes?: string | null;
  depositAmount?: number | null;
  createdByUserId: number;
  created: string;
  cancelledAt?: string | null;
  umbrellaCount: number;
  todayReservedCount: number;
  todayCheckedInCount: number;
  items: IUMBReservationItem[];
}

export interface IUMBReservationListResponse {
  items: IUMBReservation[];
  pagination: IPagination;
}

export interface IUMBStatusForDate {
  umbId: number;
  reservationId: number;
  umbReservationItemId: number;
  umbReservationDayId: number;
  customerName: string;
  customerPhone?: string | null;
  serviceDate: string;
  status: UMBReservationDayStatus;
  isActive: boolean;
}

export interface ICreateUMBReservationRequest {
  customerName: string;
  customerPhone?: string | null;
  customerEmail?: string | null;
  startDate: string;
  endDate: string;
  notes?: string | null;
  depositAmount?: number | null;
  items: Array<{
    umbId: number;
    lockedDailyPrice: number;
  }>;
}

export interface IUpdateUMBReservationRequest extends ICreateUMBReservationRequest {
  reservationId: number;
}
